// File generato automaticamente da scripts/generate-build-info.js — non modificare a mano.
export const BUILD_TIME = '2026-09-08T16:27:03.302Z';
